//////// GHG 3.1 EA
const threeOneSchema = {
  title: "3.1 Purchased Goods and Services",
  addAPI: "cat4_1AddEmissionActivityAPI",
  cat: "cat4_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "categoryISO64",
      level: 1,
      type: "trigger",
      label: "Select Category",
      required: true,
      resetOnChange: true,
      options: [
        { label: "Purchased Goods", value: "4_1" },
        { label: "Purchased Services", value: "4_5" },
      ],
    },
    //////// 如果選擇4_1
    {
      key: "goodsName",
      level: 2,
      type: "input",
      label: "Purchased Goods Name",
      resetOnChange: false,
      required: true,
      showIf: {
        all: [
          { level: 1, key: "categoryISO64", notEmpty: true },
          { level: 1, key: "categoryISO64", eq: "4_1" },
        ],
      },
    },
    {
      key: "activityId",
      level: 2,
      type: "select",
      label: "Raw Material Type",
      optionsAPI: "goodsPurchasedByAnOrganizationRawMaterialTypeAPI",
      required: false,
      showIf: {
        all: [
          { level: 1, key: "categoryISO64", notEmpty: true },
          { level: 1, key: "categoryISO64", eq: "4_1" },
        ],
      },
    },
    {
      key: "itemName",
      level: 2,
      type: "input",
      label: "Supplier Name",
      resetOnChange: false,
      required: false,
      showIf: {
        all: [
          { level: 1, key: "categoryISO64", notEmpty: true },
          { level: 1, key: "categoryISO64", eq: "4_1" },
        ],
      },
    },
    //////// 如果選擇4_5
    {
      key: "itemName",
      level: 2,
      type: "input",
      label: "Purchased Services Name",
      resetOnChange: false,
      required: true,
      showIf: {
        all: [
          { level: 1, key: "categoryISO64", notEmpty: true },
          { level: 1, key: "categoryISO64", eq: "4_5" },
        ],
      },
    },
  ],
};

export default threeOneSchema;
